import * as React from 'react';
import { connect } from 'react-redux';
import AppActions from '../../app/app_actions';
import { Utils, NumberFormatter, i18n, DateFormatter, isAuth, stringInfoVal } from 'arm-common';
import * as agui from 'arm-gui/dist/controls';
import ProdottoActions from './prodotto_actions';
import { AppConstants } from '../../constants/AppConstants';
import ProdottoTable from './prodottoTable.jsx';
import { isNullOrUndefined } from 'util';
import UploadProdottoJSON from './UploadProdottoJSON.jsx';


class ProdottoVersioniList extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ProdottoVersioniList.jsx]';
        this.createProdotto = this.createProdotto.bind(this);
        this.detailsOnClick = this.detailsOnClick.bind(this); 
        this.showPopUpUpload = this.showPopUpUpload.bind(this);
        this.state = {
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        //definisco le colonne della boostrap table
        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            { field: 'prodottoCmpPojo.compagnia.denominazione', title: i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia'), sortable: 'true', formatter: this.compagnieList },
            { field: 'idMicroCategoria', title: i18n('ARM_CORE_PRODUCT.SHARED.MICRO_CATEGORIA', 'Micro Categoria'), sortable: 'true', formatter: this.microCategoriaFormatter },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];



        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,


        });

        //effettuo la chimata rest per recuperare i dati
        this.props.getListProdottiOrgine();
        this.props.riInizializzaProdottoObject();
    }

    showPopUpUpload() {
        console.log(this.componentName + " showConfirmPanel()");

        this.setState({ showConfirm: !this.state.showConfirm })

    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== undefined && nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === undefined || null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    microCategoriaFormatter(value, row, index) {

        console.log(this.componentName + "microCategoriaFormatter:" + index);
        if (!isNullOrUndefined(row) && !isNullOrUndefined(row.microCategoria)) {
            return row.microCategoria.nome;

        }
        return '-'
    }

    compagnieList(value, row, index) {

        if (!isNullOrUndefined(row)) {
          let string = "";
          row.listaProdottoCmpPojo.map((item, index) => (
            string = string + item.compagnia.denominazione + "<br>"

          )
        )
     return string;


        }
        return '-'
    }

    createProdotto() {

        this.props.inizializzaCreazioneProdotto().then(
            resolve => {
                this.props.getListCompagnie().then(
                    resolve => {
                        this.props.history.push('/prodotto/create');

                    },
                    reject => {
                        console.log(this.getListCompagnie + ' KO');
                    }
                )
            },
            reject => {
                console.log('this.inizializzaCreazioneProdotto : ' + ' KO');
            }
        );


    }

    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);
        this.props.changeSelectedTab("home-tab");
        this.props.history.push({ pathname: '/prodotto/detailsOrgine', state: { id: row.id } });
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card">
                <div className="card-header">
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right" bs='primary' onClick={this.createProdotto} icon="fa fa-plus" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.NUOVO', 'Nuovo')} </agui.aButton>
                    }
                     <agui.aButton className="float-right mr-2" bs='primary' icon="fas fa-file-import" onClick={this.showPopUpUpload} inline={true} >{i18n('ARM_CORE_PRODUCT.SHARED.IMPORTA', 'Importa')}</agui.aButton>
                    <h3>{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTI', 'Prodotti')}</h3>
                </div>
                <div className="card-body">
                    <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
                </div>

                <UploadProdottoJSON show={this.state.showConfirm} close={this.showPopUpUpload} />
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getListProdottiOrgine() {
            return dispatch(ProdottoActions.getListProdottiOrgine());
        },
        inizializzaCreazioneProdotto() {
            return dispatch(ProdottoActions.inizializzaCreazioneProdotto());
        },
        getListCompagnie() {
            return dispatch(ProdottoActions.getListCompagnie());
        },
        changeSelectedTab(idTab) {
            return dispatch(ProdottoActions.changeSelectedTab(idTab));
        },
        riInizializzaProdottoObject() {
            return dispatch(ProdottoActions.riInizializzaProdottoObject())
        }
    }
};

function mapStateToProps(state) {
    return {
        rows: state.prodotto.listProdottiOrigine,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(ProdottoVersioniList);
